import classNames from "./Empty.module.css";
import emptyImg from "../../assets/empty.svg";
import { ReactNode } from "react";

const Empty = (props: { message: ReactNode }) => {
  return (
    <div className={classNames.Empty}>
      <img src={emptyImg} alt="No meetings" />
      <h3>{props.message}</h3>
    </div>
  );
};

export default Empty;
